import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DataQualityWarningAssetFragmentGql } from './DataQualityWarningAssetFragmentGql';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';

export const EmbeddedDatasourceLineageUpstreamDataQualityWarningsQueryGql: DocumentNode = gql`
query EmbeddedDatasourceLineageUpstreamDataQualityWarningsQuery($embeddedDatasourceId: ID!, $first: Int!, $offset: Int!, $publishedConnectionsLineageEnabled: Boolean!) {
  embeddedDatasources(filter: {id: $embeddedDatasourceId}) {
    upstreamDataQualityWarningsConnection (filter: {isActive: true},
                                           first: $first, offset: $offset,
                                           orderBy: {field: IS_SEVERE, direction: DESC}) {
      totalCount
      nodes {
        ...DataQualityWarningFragment
        ...DataQualityWarningAssetFragment
      }
    }
  }
}

${DataQualityWarningFragmentGql}
${DataQualityWarningAssetFragmentGql}
`;
